<template>
  <div>
    <label for="ticketType" class="mb-1" v-if="!hideLabel">{{ title }}</label>
    <multiselect
      id="ticketType"
      v-model="selectedValue"
      trackBy="id"
      label="name"
      placeholder="Select type to search"
      open-direction="bottom"
      :class="className"
      :options="options"
      :multiple="true"
      :searchable="false"
      :internal-search="true"
      :max-height="600"
      :limit="1"
      :show-no-results="false"
      :hide-selected="false"
      :show-labels="false"
      @search-change="asyncFind"
      @select="onChange($event, 1)"
      @remove="onChange($event, 0)"
    >
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      required: true,
      type: Array,
    },
    title: {
      required: false,
      default: "Type",
    },
    hideLabel: {
      required: false,
      type: Boolean,
      default: false,
    },
    className: {
      required: false,
    },
  },
  data() {
    return {
      options: [],
      filter: {
        search: "",
      },
      isLoading: false,
      selectedValue: this.value,
    };
  },
  async mounted() {
    this.getList();
  },
  watch: {
    async value(newValue) {
      this.selectedValue = newValue;
    },
  },
  methods: {
    getList: async function () {
      this.isBusy = true;

      const { data } = await this.axios.get(`/ticket/filter/6`);
      if (data.result == 1) {
        this.options = data.detail;
      }
      this.isBusy = false;
    },

    asyncFind(query) {
      this.filter.search = query;
      this.getList();
    },
    onChange() {
      this.$emit("change", this.selectedValue);
    },
  },
};
</script>

<style lang="scss" scoped></style>
